var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#552049",
    width: 64,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 48,
    cy: 16,
    r: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14h4v4H0zM4 14h4v4H4zM28 14h4v4h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#755CDE",
    d: "m32 0 32 32V0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 14h4v4h-4zM56 14h4v4h-4zM60 14h4v4h-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternApps);
export default __webpack_public_path__ + "static/media/pattern-apps.ee7a4747a8a7117f4cce78d8f443e4a6.svg";
export { ForwardRef as ReactComponent };